module.exports = __webpack_public_path__ + "img/full3-min.6b7ac875.png";